import { render, staticRenderFns } from "./PMDashboardTable.vue?vue&type=template&id=7035b7a5&scoped=true&"
import script from "./PMDashboardTable.vue?vue&type=script&lang=js&"
export * from "./PMDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardTable.vue?vue&type=style&index=0&id=7035b7a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035b7a5",
  null
  
)

export default component.exports